import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { validateType } from '@app/hcs-shared';
export const Operator_GetPatientVar = 'PV({id})';
const mockResolvePatientDataMapper = {
    'f0c83c5387e2d526d04adb578093b46f': 'yes',
    'c75c8e4d316eb0ce95421c42a2309adb': 6
};
const mockResolvePatientInterface = (varId) => {
    return mockResolvePatientDataMapper[varId];
};
export const QuaiExpressions_ResolveVariablesProcessors = {
    [Operator_GetPatientVar]: (_expressionModule, ...params) => {
        const value = mockResolvePatientInterface(_expressionModule.params.eval(params[0]));
        if (!value)
            throw new MUSTNeverHappenException('patient variable with this id doesn\'t exist');
        return value;
    }
};
export const QuaiExpressions_ResolveVariablesPrinter = {
    [Operator_GetPatientVar]: (_expressionModule, indent, ...params) => `(PV{${params[0]}})`
};
export const QuaiExpressions_ResolveVariablesValidation = {
    [Operator_GetPatientVar]: (_expressionModule, ...params) => {
        validateType(params[0], 'left', 'string');
    }
};
export const QuaiExpressions_ResolveVariableOperators = [Operator_GetPatientVar];
export const QuaiExpressions_ResolveVariablesOptions = {
    Operators: QuaiExpressions_ResolveVariableOperators,
    OperatorPrinter: QuaiExpressions_ResolveVariablesPrinter,
    OperatorProcessors: QuaiExpressions_ResolveVariablesProcessors,
    OperatorValidation: QuaiExpressions_ResolveVariablesValidation
};
export const quaiOptions = [
    QuaiExpressions_ResolveVariablesOptions
];
//# sourceMappingURL=consts.js.map